import { useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import Download from 'yet-another-react-lightbox/plugins/download'
import 'yet-another-react-lightbox/styles.css'
import './Pages.css'
import './Photos.css'

const photos = [
    { src: '/images/group/_DSC6809.JPG', alt: 'Kazoku Quartet', size: 'featured' },
    { src: '/images/group/EGC09548A.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/DSC05339.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/_DSC6837.JPG', alt: 'Kazoku Quartet', size: 'wide' },
    { src: '/images/group/DSC05479.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/13.jpg', alt: 'Kazoku Quartet', size: 'tall' },
    { src: '/images/group/EGC09430A.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/DSC05352.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/1.jpeg', alt: 'Kazoku Quartet', size: 'wide' },
    { src: '/images/group/_DSC6708.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/DSC05391.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/EGC09477A.JPG', alt: 'Kazoku Quartet', size: 'featured' },
    { src: '/images/group/5.png', alt: 'Kazoku Quartet' },
    { src: '/images/group/_DSC6862.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/9.jpeg', alt: 'Kazoku Quartet', size: 'wide' },
    { src: '/images/group/DSC05403.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/8.jpeg', alt: 'Kazoku Quartet' },
    { src: '/images/group/_DSC6902.JPG', alt: 'Kazoku Quartet', size: 'wide' },
    { src: '/images/group/EGC09419A.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/19.png', alt: 'Kazoku Quartet', size: 'tall' },
    { src: '/images/group/DSC05524.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/KQ_012.jpeg', alt: 'Kazoku Quartet', size: 'featured' },
    { src: '/images/group/10.jpg', alt: 'Kazoku Quartet' },
    { src: '/images/group/DSC05534.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/DSC05328.JPG', alt: 'Kazoku Quartet' },
    { src: '/images/group/17.png', alt: 'Kazoku Quartet' },
    { src: '/images/group/DSC05370.JPG', alt: 'Kazoku Quartet', size: 'wide' },
    { src: '/images/group/18.png', alt: 'Kazoku Quartet', size: 'tall' },
    { src: '/images/group/_DSC6640b.jpg', alt: 'Kazoku Quartet' },
    { src: '/images/group/_DSC6821.JPG', alt: 'Kazoku Quartet', size: 'wide' },
]

function Photos() {
    const [index, setIndex] = useState(-1)
    
    return (
        <div className="page">
            <h1>Photos</h1>
            <div className="photos-grid">
                {photos.map((photo, i) => (
                    <div 
                        key={photo.src}
                        className={`photos-item ${photo.size || ''}`}
                    >
                        <img
                            src={photo.src}
                            alt={photo.alt}
                            className="photos-thumb"
                            onClick={()=> setIndex(i)}
                        />
                    </div>
                    ))}
            </div>
            
            <Lightbox
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                slides={photos}
                plugins={[Download]}
            />
        </div>
    );
}

export default Photos; 